<template>
  <div style="  background-color: #f6f6f6;">
    <van-nav-bar title="闲置" left-text="返回" right-text left-arrow fixed />
    <div style="height:46px"></div>
    <van-tabs v-model="active" sticky @change="tabChange">
      <van-tab :title="t.name" v-for="t in tabs" :key="t.id" :name="t.id">
        <van-list
          class="goodsList"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <router-link
            :to="'/second/detail/'+item.id"
            class="item"
            v-for="item in list"
            :key="item.id"
          >
            <van-image
              style="background-color:#F7F8FA"
              width="100%"
              fit="contain"
              :src="GLOBAL.IMG + item.img[0]"
            />
            <div class="title">{{item.title}}{{item.content}}</div>

            <div class="userInfo">
              <div class="av">
                <img :src="item.avatar" />
              </div>
              <div class="user-name">{{item.user_nickname}}</div>
            </div>
          </router-link>
        </van-list>
      </van-tab>
    </van-tabs>
    <i class="add iconfont iconfabu" v-on:click="secondAdd()"></i>
    <TabBar active="3" />
  </div>
</template>
<script>
import TabBar from "@/components/TabBar.vue";
import Vue from "vue";
import { Tab, Tabs } from "vant";

Vue.use(Tab);
Vue.use(Tabs);
export default {
  name: "secondList",
  components: {
    TabBar
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      cPage: 1,
      tabs: [
        { name: "转卖", id: 21 },
        { name: "求购", id: 19 }
      ],
      active: 0,
      type:21,
    };
  },
  methods: {
    tabChange(name) {
        this.type = name;
        this.list = [];
        this.cPage = 1;
        this.loading=false;
        this.finished=false;
        // this.onLoad();
    },
    onLoad() {
      this.$http
        .get(this.GLOBAL.API + "s_xianyu/Supply/supply_list", {
          params: { id: this.type, page: this.cPage }, //id=19求购，id=21出售
          headers: { "XX-Device-Type": "mobile" }
        })
        .then(response => {
          let data = response.body;
          this.loading = false;
          if (this.cPage >= data.data.last_page) {
            this.finished = true;
          } else {
            this.cPage++;
          }
          if (data.code == 1) {
            this.list = this.list.concat(data.data.data); //= data.data.data;
          }
        });
    },
    secondAdd(){
        this.$router.push('/second/add')
    },
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.goodsList {
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-wrap: wrap;
  text-align: left;
  .item {
    margin-top: 5px;
    background-color: #ffffff;
    width: 49.5%;
    .title {
      line-height: 20px;
      height: 40px;
      overflow: hidden;
      padding: 0 5px 10px 10px;
    }
    .userInfo {
      margin-top: 10px;
      line-height: 30px;
      height: 40px;
      overflow: hidden;
      display: flex;
      padding: 0 10px 10px 10px;
      .av {
        img {
          width: 30px;
          height: 30px;
          border-radius: 15px;
        }
      }
      .user-name {
        padding-left: 10px;
      }
    }
  }
}
.add{
    position: fixed;
    bottom:60px;
    right:10px;
    font-size: 50px;
    color:red;
}
</style>